import { AgentsStore } from "./agentsTypes";

export const selectAgentsDetails = (state: AgentsStore) => state.agentsDetails;
export const selectAgentsCountWithSegregation = (state: AgentsStore) => state.agentsCountWithSegregation;
export const selectAgentPermissions = (state: AgentsStore) => state.agentPermissions;
export const selectAvailableFilters = (state: AgentsStore) => state.availableFilters;
export const selectPageSize = (state: AgentsStore) => state.pageSize;
export const selectPageIndex = (state: AgentsStore) => state.pageIndex;
export const selectSearchParam = (state: AgentsStore) => state.searchParam;
export const selectFilters = (state: AgentsStore) => state.filters;
export const selectSortRequest = (state: AgentsStore) => state.sortRequest;
export const selectIsAgentsLoading = (state: AgentsStore) => state.isAgentsLoading;
export const selectTotalAgents = (state: AgentsStore) => state.agentsCountWithSegregation.totalAgents;
